/**
 * A lightweight labelled divider that groups the page into sections. Sits above
 * a cluster of cards and reads as a quieter tier than the bold per-card headings
 * so the two levels don't compete. The danger tone tints the rule + label red for
 * the Danger-zone group.
 */
export function SectionDivider({
  label,
  tone = 'default',
}: {
  label: string;
  tone?: 'default' | 'danger';
}) {
  const danger = tone === 'danger';
  return (
    <h2
      className={`mt-2 border-t pt-4 text-2xs font-bold uppercase tracking-[0.14em] ${
        danger ? 'border-danger/30 text-danger' : 'border-line text-ink-faint'
      }`}
    >
      {label}
    </h2>
  );
}
